const runtimeConfig = {
    environment: "Dev",
    apiUrl: "https://localhost:5001",
    clientId: 0,
    clientCode: ""
};
